import { ReactNode } from 'react'
import styled from 'styled-components'
import CountChip from './CountChip'

export interface ToolbarProps {
  title?: ReactNode
  count?: ReactNode
  /** Free slot for actions placed by the consuming module (search, buttons, filters). */
  children?: ReactNode
}

/**
 * Composable grid header. Renders an optional title + count chip on the start side
 * and hands the rest of the row to `children` (the action slot).
 */
export const Toolbar = ({ title, count, children }: ToolbarProps) => (
  <Root>
    {title != null && (
      <TitleWrap>
        <Title>{title}</Title>
        {count != null && <CountChip>{count}</CountChip>}
      </TitleWrap>
    )}
    <Spacer />
    {children}
  </Root>
)

export default Toolbar

const Root = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  padding: 1em;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
`

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const Title = styled.h3`
  font-size: ${({ theme }) => theme.text.xl};
  font-weight: 600;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.ink};
`

const Spacer = styled.div`
  flex: 1;
`
